import { LineInfoCircle } from '@qr-front/icons/line-info-circle'

export const ExistingAccountNotice = ({ message }: { message: string }) => (
	<div className="flex w-full items-start gap-2 rounded-10 bg-purple-8 p-2 text-start">
		<div className="flex size-[22px] shrink-0 items-center justify-center">
			<LineInfoCircle className="size-4 text-blue" />
		</div>
		<p className="type-body-small text-black">{message}</p>
	</div>
)
